<template>
  <div class="pub-page">
    <div class="pub-header d-flex align-items-center justify-content-between">
      <text class="title">{{$route.meta.title}}</text>
    </div>

<!--     初赛成绩-->
    <div class="pub-center" v-loading="infoLoading" >
      <div style="width: calc(100% - 30px);position: absolute;left: 15px;top:10px;padding-bottom: 30px;overflow-x: auto" class="d-flex align-items-center flex-column">
        <el-card  class="mt-3 card-style">
          <template #header>
            <div class="card-header w-100 position-relative">
            <span class="fw-bold fs-3">初赛成绩：
               <text class="text-primary fs-3" v-if="status==2">初赛一等奖</text>
              <text class="text-primary fs-3" v-else-if="status==4">初赛二等奖</text>
               <text class="text-primary fs-3" v-else>未公布或未获奖</text>
            </span>
              <el-button type="primary" class="position-absolute download-icon"   v-if="(status==2 || status==4) && preCertNoUrl" >
                <a class="text-white text-decoration-none" :href="preCertNoUrl" >初赛证书下载</a>
              </el-button>
            </div>
          </template>
<!--          获奖了，但是证书正在制作中-->
          <div v-if="(status==2 || status==4) && !preCertNoUrl" class="nodata d-flex align-items-center justify-content-center" >
            <text >您的证书正在制作中</text>
          </div>
<!--          获奖了，而且存在证书-->
          <el-image v-if="(status==2 || status==4) && preCertNoUrl" class="pic-style" lazy  :src="preCertNoUrl">
            <template #error>
              <div class="image-slot">
                <el-icon><icon-picture /></el-icon>
              </div>
            </template>
            <template #placeholder>
              <div  class="image-placeholder" v-loading="true" element-loading-text="Loading..."
                    element-loading-svg-view-box="-10, -10, 50, 50"
                    element-loading-background="rgba(122, 122, 122, 0.8)">
                <i class="el-icon-loading"></i>
                <span>正在获取您的证书...</span>
              </div>
            </template>

          </el-image>
        </el-card>
      </div>
    </div>

  </div>
</template>

<script setup>
import {computed, onMounted, reactive, ref} from "vue";
import { Picture as IconPicture } from '@element-plus/icons-vue'
import {ElMessage, ElMessageBox} from "element-plus";
import {useStore} from "vuex";
import {downloadFiles, downloadImage} from "@/utils/downloadFiles";
const store = useStore()
const userInfo = ref({})
const infoLoading = ref(true) // 获取信息
const preCertNoUrl = ref() // 获奖证书
const enterFinal = ref(false) // 是否进入决赛
const status = ref()// 获奖状态 :int 类型，初赛成绩。0:"未设置”,1:"未设置”,2:"初赛一等奖(进入复赛)”,3:"初赛淘汰”,4:"初赛二等奖"







onMounted(()=>{
  getUserInfo()// 获取用户信息
})



// 获取用户信息
const getUserInfo = async  ()=>{
  infoLoading.value = true
  await store.dispatch("loginModel/getUserInfo") //获取用户信息
  const u = store.getters["loginModel/getUserInfo"] || {}
  userInfo.value = u
  enterFinal.value = u.enterFinal
  preCertNoUrl.value = "https://bsc.mnmcloud.com" + u.preCertNoUrl
  // preCertNoUrl.value = u.preCertNoUrl
  status.value = u.status
  infoLoading.value = false
}










</script>

<style scoped lang="scss">
.card-style{
  width: 100%;
  max-width: 1200px;
  min-width: 600px;
}
.pic-style{
  width: 90%;
  height: auto;
}
.nodata{
  width: 100%;
  height: 400px;
}
.download-icon{
  right: 0;
  top: -1px;
}
.image-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: #f5f7fa;
}
.image-placeholder i {
  font-size: 24px;
  margin-bottom: 10px;
}
</style>
